import { Box } from 'src/design/atoms/Box';
import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { IconBulb } from '@tabler/icons-react';
import React from 'react';
import { FireIcon } from 'src/design/atoms/FireIcon';
import { UsedMemoryChip } from 'src/app/chat/UsedMemoryChip';

export interface IAssistantReplyFooterProps {
  thoughtHarder?: boolean;
  /** Memory note ids the reply reported using; omit to hide the Used memory chip. */
  usedMemoryIds?: number[];
}

const ICON_STYLE: React.CSSProperties = {
  display: 'flex',
  flexShrink: 0,
  color: 'var(--mantine-color-dimmed)',
};

/** @registry Quiet footer inside an assistant reply bubble: a "Used memory" chip when the reply used memory notes, a "Thought harder" note when it used the Think harder effort, then the AI-accuracy disclaimer. */
export const AssistantReplyFooter: React.FC<IAssistantReplyFooterProps> = ({
  thoughtHarder,
  usedMemoryIds,
}) => (
  <Stack gap={2}>
    {!!usedMemoryIds?.length && (
      <UsedMemoryChip usedMemoryIds={usedMemoryIds} />
    )}
    {thoughtHarder && (
      <Group gap={4} wrap="nowrap" align="center">
        <Box style={ICON_STYLE}>
          <IconBulb size={14} aria-hidden />
        </Box>
        <Text size="xs" c="dimmed">
          Thought harder
        </Text>
      </Group>
    )}
    <Group gap={4} wrap="nowrap" align="center">
      <Box style={ICON_STYLE}>
        <FireIcon size={14} />
      </Box>
      <Text size="xs" c="dimmed">
        AI can make mistakes. Double-check for accuracy.
      </Text>
    </Group>
  </Stack>
);
